import React from 'react';

const FounderSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-serif text-neutral-800 mb-6 tracking-wide">
              From the Founder
            </h2>
            <p className="text-neutral-700 mb-6 leading-relaxed">
              "Gifting is deeply personal to me. It's not just about the object itself, but the thought, care, and intention behind it. Every gift tells a story, creates a memory, and strengthens a bond."
            </p>
            <p className="text-neutral-700 mb-6 leading-relaxed">
              At Guriva, we believe that the art of gifting goes beyond the material. It's about understanding the recipient, celebrating moments, and creating experiences that last long after the ribbon is untied.
            </p>
            <p className="text-neutral-700 mb-8 leading-relaxed">
              Each piece in our collection is selected with the same care and attention I would give to a gift for someone I love. Because that's what Guriva represents - gifts made with intention and care.
            </p>
            <div className="border-t border-neutral-200 pt-6">
              <p className="font-serif text-lg text-neutral-800">Preity Pangotra</p>
              <p className="text-sm text-neutral-600 tracking-wide">Founder, Guriva</p>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="relative flex justify-center lg:justify-end">
              <div className="w-64 md:w-72 lg:w-80 aspect-[3/4] bg-neutral-100 overflow-hidden rounded-2xl shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_851c8424-587a-44ab-b417-d2a09cb449a0/artifacts/ohho3kcw_WhatsApp%20Image%202026-01-21%20at%2012.02.02%20AM.jpeg"
                  alt="Preity Pangotra, Founder of Guriva"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gradient-to-br from-amber-100 to-amber-200 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;